import Vue from 'vue'
import App from './App.vue'
import '../scss/custom.scss'
import 'promise-polyfill/src/polyfill'
import 'whatwg-fetch'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
